// This is a client-side-only component

let initialized = false;

const locationContext = (windowLocation) => {
  const { host, hostname, href, origin, pathname, port, protocol, search } =
    windowLocation;

  return {
    host,
    hostname,
    href,
    origin,
    pathname,
    port,
    protocol,
    search
  };
};

class Data {
  constructor() {
    this.handlers = {};
  }

  registerDataHandler(dataId, fnThatReturnsAPromise) {
    if (dataId && fnThatReturnsAPromise) {
      this.handlers[dataId] = fnThatReturnsAPromise;
      return true;
    }
    return false;
  }

  getData(dataId) {
    if (this.handlers[dataId]) {
      const dataSet = this.handlers[dataId].call();
      return dataSet.then ? dataSet : Promise.resolve(dataSet);
    }
    return Promise.reject(
      new Error(`Unsupported data type: ${dataId} was specified`)
    );
  }
}

const initializeCSA = (isCSAEnabled = false) => {
  if (initialized || !isCSAEnabled) return null;
  if (typeof window === "undefined") return;

  const PubSub = require("@appfabric/pubsub");

  if (typeof window.coreServiceAdapter === "undefined") {
    window.coreServiceAdapter = {};
  }
  window.coreServiceAdapter.data = new Data();
  window.coreServiceAdapter.messaging = new PubSub();

  window.coreServiceAdapter.data.registerDataHandler("config", () => {
    return new Promise((resolve) => {
      resolve(window.appVars);
    });
  });

  window.coreServiceAdapter.data.registerDataHandler("widgetsConfig", () => {
    return new Promise((resolve) => {
      resolve(window.appVars.widgetsConfig);
    });
  });

  window.coreServiceAdapter.data.registerDataHandler("context", () => {
    const location = locationContext(window.location);
    const context = {
      location
    };
    return new Promise((resolve) => {
      resolve(context);
    });
  });
  initialized = true;
  // Note: This component doesn't show anything. It simply initializes the coreServiceAdapter.
  return null;
};

export default initializeCSA;
